import { useMemo } from 'react'
import { PersonOffOutlined } from '@mui/icons-material'
import { styled } from '@mui/material'
import { Avatar } from '@carto/meridian-ds/components'

import UserAvatar from 'features/users/ui/UserAvatar'
import { User } from 'features/users/types'
import { CommentUserInfo } from 'features/collaboration/types'
import { UserLike } from 'features/users/model/user'

const StyledAvatar = styled(Avatar, { shouldForwardProp: (prop) => prop !== 'deactivated' })<{
  deactivated?: boolean
}>(({ theme, deactivated }) => ({
  backgroundColor: 'unset',
  ...(deactivated && {
    backgroundColor: theme.palette.action.disabledBackground,
    color: theme.palette.action.disabled
  })
}))

function CommentAuthorAvatar({
  user: cartoUser,
  author,
  disabled
}: {
  user?: User
  author: CommentUserInfo
  disabled?: boolean
}) {
  const user = useMemo(() => {
    if (cartoUser) return cartoUser

    return {
      user_id: author.id,
      name: author.email,
      email: author.email,
      picture: author.avatar
    } as UserLike
  }, [author, cartoUser])

  const deletedUser = author.deactivated
  if (deletedUser) {
    return (
      <StyledAvatar size="small" deactivated>
        <PersonOffOutlined />
      </StyledAvatar>
    )
  }
  return <UserAvatar size="small" disabled={disabled} user={user} AvatarComponent={StyledAvatar} />
}

export default CommentAuthorAvatar
